import React from 'react';
import Typography from '@mui/material/Typography';

const sessionExpired = () => (
    <div>
        <Typography variant="h2">Something went wrong. Please try again.</Typography>
    </div>
)

export default sessionExpired;